/* eslint-disable max-len */
import React from 'react';

const AdvancedSearchHelper = () => (
  <div className="advanced-search-helper">
    <div className="help-operators">
      <h4>Help operators</h4>
      <table>
        <tbody>
          <tr title="Find all words, e.g.: motion AND 363">
            <td>AND</td><td>All Words</td>
          </tr>
          <tr title="Find at least one of the words, e.g.: motion OR 363">
            <td>OR</td><td>Either Word</td>
          </tr>
          <tr title="Find these words within n words of each other, e.g.: motion /3 363">
            <td>/n</td><td>Within <var>n</var> terms of</td>
          </tr>
          <tr title="Find this sequence of words exactly as typed, e.g.: &quot;order on motion for relief from stay&quot;">
            <td>"_"</td><td>Phrase</td>
          </tr>
          <tr title="Find results without this word, e.g.: order -relief">
            <td>-word</td><td>But not</td>
          </tr>
          <tr title="Find words that start or end as specified, e.g.: evid*">
            <td>*</td><td>Wildcard</td>
          </tr>
          <tr title="Find group of words, e.g.: (order on motion) for (relief from stay)">
            <td>( )</td><td>Grouping</td>
          </tr>
        </tbody>
      </table>
    </div>
    {/*<div className="help-link">
      <a
        href="http://support.courtdrive.com/hc/en-us/articles/205450048-How-do-I-search-across-cases-using-keywords-and-filters-"
        target="_blank"
      >
        To learn more about using our Advanced Search, please read our Knowledge Base
      </a>
    </div>*/}
  </div>
);

export default AdvancedSearchHelper;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/AdvancedSearchHelper.jsx